<mat-card class="cb-margin-bottom cb-margin-top flex-row">
    <mat-card-content>
        <button class="cb-margin-left" mat-raised-button color="primary" (click)="goBackToSearch()">
            <mat-icon>arrow_back</mat-icon>
            Concepts
        </button>
        <button
            class="cb-margin-left"
            mat-raised-button
            color="primary"
            [matMenuTriggerFor]="optionsMenu"
            [disabled]="optionsMenuDisabled()"
        >
            <mat-icon>more_horiz</mat-icon>
            Options
        </button>
        <mat-menu #optionsMenu="matMenu">
            @if (canApplyConcept()) {
                <button
                    mat-menu-item
                    (click)="applyDesignConceptToLot()"
                    [disabled]="!canApplyToLot()"
                >
                    <mat-icon>date_range</mat-icon>
                    Apply To Lot
                </button>
            }
            @if (canSetConceptExpiryDate()) {
                <button mat-menu-item (click)="setExpiryDate()">
                    <mat-icon>date_range</mat-icon>
                    Set Expiry Date
                </button>
            }
            @if (hasPermissionToSetLotAvailableForSale()) {
                <button
                    mat-menu-item
                    (click)="makeLotAvailableForSale()"
                    [disabled]="!canSetLotAvailableForSale()"
                >
                    <mat-icon>library_books</mat-icon>
                    Make Lot Available for Sale
                </button>
            }
            @if (canSetConceptSellPrice()) {
                <button mat-menu-item (click)="setSellPrice()">
                    <mat-icon>attach_money</mat-icon>
                    Set Sell Price
                </button>
            }
            @if (canRequestImages()) {
                <button mat-menu-item (click)="requestExteriorImage()">
                    <mat-icon>panorama</mat-icon>
                    Request Exterior Image
                </button>
            }
            @if (canRequestImages()) {
                <button mat-menu-item (click)="requestFloorPlanImage()">
                    <mat-icon>image</mat-icon>
                    Request Floor Plan Image
                </button>
            }
            @if (canAbandonConcept()) {
                <button mat-menu-item (click)="abandonConcept()" [disabled]="abandonDisabled()">
                    <mat-icon>cancel</mat-icon>
                    Abandon Concept
                </button>
            }
        </mat-menu>
    </mat-card-content>
</mat-card>
<div class="flex-row" style="gap: 16px">
    <cb-design-concept-info [designConcept]="designConcept"> </cb-design-concept-info>
    <cb-design-concept-view class="flex" [mappedItem]="designConcept"> </cb-design-concept-view>
</div>
